import { Link } from "react-router-dom";
import useMetaTags from "../hooks/useMetaTags"; // Adjust path based on your project structure
const blogPosts = [
  {
    title: "Why Choose Organic Pads?",
    slug: "why-choose-organic-pads",
    excerpt: "Discover the benefits of using organic sanitary pads for a healthier and eco-friendly period.",
    image: "https://img.freepik.com/premium-photo/sanitary-pad-cotton-pink-surface_185193-12171.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
  },
  {
    title: "Eco-Friendly Period Care",
    slug: "eco-friendly-period-care",
    excerpt: "Learn how switching to eco-friendly sanitary products can help the environment and your body.",
    image: "https://img.freepik.com/free-photo/close-up-hand_23-2149149983.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
  },
  {
    title: "Understanding Period Health",
    slug: "understanding-period-health",
    excerpt: "A guide to understanding menstrual health and why choosing the right products matters.",
    image: "https://img.freepik.com/free-photo/doctors-coat-with-flowers-clipboard-pen-uterus-doctor-gynecologist_185193-108339.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
  },
  {
    title: "The Environmental Impact of Traditional Sanitary Pads",
    slug: "environmental-impact-traditional-pads",
    excerpt: "Learn how switching to eco-friendly sanitary products can help the environment and your body.",
    image: "https://img.freepik.com/premium-photo/covid19-plastic-waste-garbage-disposable-masks-alcohol-gel-bottle-needle-trash-bin_53476-6132.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
  },
  {
    title: "Understanding the Health Risks of Conventional Sanitary Pads",
    slug: "health-risks-conventional-pads",
    excerpt: "Discover the benefits of using organic sanitary pads for a healthier and eco-friendly period.",
    image: "https://images.unsplash.com/photo-1712842955521-55c8c01ef148?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8b3JnYW5pYyUyMHNhbml0YXJ5JTIwcGFkc3xlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    title: "Why Organic Pads Are Better for Sensitive Skin",
    slug: "organic-pads-sensitive-skin",
    excerpt: "A guide to understanding menstrual health and why choosing the right products matters.",
    image: "https://images.pexels.com/photos/3958547/pexels-photo-3958547.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    title: "How Organic Pads Help Reduce Menstrual Waste",
    slug: "reduce-menstrual-waste-organic-pads",
    excerpt: "A guide to understanding menstrual health and why choosing the right products matters.",
    image: "https://images.unsplash.com/photo-1706535426949-e90f953f0d6d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NjZ8fGNvdHRvbiUyMG5hdHVyYWwlMjBzYW5pdGFyeSUyMHBhZHxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    title: "The Role of Organic Pads in Feminine Hygiene",
    slug: "organic-pads-feminine-hygiene",
    excerpt: "A guide to understanding menstrual health and why choosing the right products matters.",
    image: "https://images.pexels.com/photos/7691793/pexels-photo-7691793.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    title: "Why Organic Pads are the Future of Menstrual Care",
    slug: "future-of-menstrual-care",
    excerpt: "A guide to understanding menstrual health and why choosing the right products matters.",
    image: "https://plus.unsplash.com/premium_photo-1664375262056-a8503d4d073c?q=80&w=1976&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    title: "How Organic Pads Support Women's Health",
    slug: "organic-pads-support-womens-health",
    excerpt: "A guide to understanding menstrual health and why choosing the right products matters.",
    image: "https://plus.unsplash.com/premium_photo-1702598845073-282b7c56da37?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8ZmVtYWxlJTIwaHlnaW5lJTIwbWVuc3RydWFsJTIwY2FyZXxlbnwwfHwwfHx8MA%3D%3D",
  },
  {
    title: "Making Organic Period Care Affordable: Budget-Friendly Solutions",
    slug: "affordable-organic-period-care",
    excerpt: "Organic menstrual care doesn't have to break the bank. Learn how to make sustainable choices while staying within your budget.",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=600",
  },
  {
    title: "Staying Active During Periods: Why Organic Pads Are Better for Exercise",
    slug: "exercise-sports-during-period-organic",
    excerpt: "Organic pads offer superior breathability and comfort during physical activity.",
    image: "https://images.pexels.com/photos/4498151/pexels-photo-4498151.jpeg?w=600",
  },
  {
    title: "How Hormones Affect Your Period and Why Organic Products Matter",
    slug: "hormones-menstruation-organic-products",
    excerpt: "Understanding the relationship between hormones and menstruation can help you make better choices about menstrual products.",
    image: "https://img.freepik.com/free-photo/communication-using-biology-document-uniform_1134-1421.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
  },
  {
    title: "Managing Heavy Flow: The Organic Solution to Heavy Periods",
    slug: "managing-heavy-periods-organic-solutions",
    excerpt: "Organic pads with enhanced absorption capabilities offer a natural solution without compromising on health or comfort.",
    image: "https://img.freepik.com/free-photo/sanitary-towel-with-red-fur_23-2148025780.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
  },
  {
    title: "Dealing with Allergies: The Organic Solution to Menstrual Sensitivities",
    slug: "menstrual-allergies-organic-solutions",
    excerpt: "Organic pads offer a hypoallergenic alternative that can help prevent and relieve allergic reactions during your period.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600",
  },
  {
    title: "Natural Period Pain Management: How Organic Products Help",
    slug: "natural-period-pain-management",
    excerpt: "Period pain can be influenced by the products you use. Organic pads, free from irritating chemicals, can help reduce discomfort.",
    image: "https://img.freepik.com/free-photo/young-beautiful-woman-red-pajamas-relaxing-bed_141793-47262.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
  },
  {
    title: "Choosing the Right Overnight Protection: Why Organic Night Pads Matter",
    slug: "overnight-protection-organic-pads",
    excerpt: "Organic night pads offer superior absorption while maintaining skin health during extended use.",
    image: "https://img.freepik.com/free-photo/sanitary-towel-line-with-glitter_23-2148025792.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
  },
  {
    title: "Traveling With Your Period: Organic Solutions for On-the-Go",
    slug: "period-travel-organic-solutions",
    excerpt: "Organic pads offer reliable, portable protection that's perfect for travel while maintaining your commitment to health and sustainability.",
    image: "https://img.freepik.com/free-photo/happy-young-woman-wearing-red-shirt-holding-yellow-suitcase-with-wall-clock-while-looking-side-white-wall_141793-31247.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
  },
  {
    title: "Post-Pregnancy Period Care: Why Organic Matters More Than Ever",
    slug: "post-pregnancy-period-care",
    excerpt: "Organic pads offer gentle, chemical-free protection for your body during this sensitive recovery phase.",
    image: "https://img.freepik.com/free-photo/medium-shot-time-month-period-calendar_23-2148381549.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
  },
  {
    title: "A Teenager's Guide to First Period: Why Start With Organic",
    slug: "teens-first-period-organic-guide",
    excerpt: "This guide helps teenagers understand why choosing organic from the start matters and how to navigate their first period confidently.",
    image: "https://images.unsplash.com/photo-1576678927484-cc907957088c?w=600",
  }
];

const Blogs = () => {
  useMetaTags({
    title: "Blog | Organic Pads - Sustainable Menstrual Care Insights",
    description: "Explore our latest blogs on sustainable menstrual care, eco-friendly period products, and women's health. Stay informed with Organic Pads.",
    keywords: "organic pads blog, sustainable menstrual care blog, eco-friendly period tips, women's health insights, green menstrual products",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/blog",
    ogTitle: "Blog | Organic Pads - Sustainable Menstrual Care Insights",
    ogDescription: "Discover insightful blogs on sustainable menstrual care, eco-friendly period products, and women's health. Stay informed with Organic Pads.",
    ogImage: "https://organicpads.shop/images/blogs-banner.jpg",
    ogUrl: "https://organicpads.shop/blog",
    ogType: "website",
    twitterCard: "summary_large_image",
    twitterTitle: "Blog | Organic Pads - Sustainable Menstrual Care Insights",
    twitterDescription: "Read the latest blogs on sustainable menstrual care, eco-friendly period products, and women's health at Organic Pads.",
    twitterImage: "https://organicpads.shop/images/blogs-banner.jpg",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
});
const schemaMarkup = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Organic Pads Blog",
  "description": "Explore the latest blogs on sustainable menstrual care, eco-friendly period products, and women's health.",
  "publisher": {
    "@type": "Organization",
    "name": "Organic Pads",
    "url": "https://organicpads.shop",
    "logo": "https://organicpads.shop/images/logo.png"
  },
  "mainEntity": {
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "BlogPosting",
        "headline": "Blog Title 1",
        "url": "https://organicpads.shop/blog/blog-title-1",
        "datePublished": "2025-02-24",
        "author": {
          "@type": "Person",
          "name": "Organic Pads Team"
        }
      },
      {
        "@type": "BlogPosting",
        "headline": "Blog Title 2",
        "url": "https://organicpads.shop/blog/blog-title-2",
        "datePublished": "2025-02-20",
        "author": {
          "@type": "Person",
          "name": "Organic Pads Team"
        }
      }
    ]
  },
  "sameAs": [
    "https://www.facebook.com/OrganicPads",
    "https://www.instagram.com/OrganicPads",
    "https://www.linkedin.com/company/OrganicPads"
  ]
}

  return (
    <>
    <div className="min-h-screen bg-gray-100 py-10">
      <div className="max-w-6xl mx-auto pt-10 px-4">
        <h1 className="text-4xl font-bold text-center text-[#679729] mb-8">Our Blog</h1>
        <p className="text-center text-gray-600 mb-10">
          Explore the latest insights on menstrual health, organic pads, and sustainable wellness.
        </p>
        
        <div className="grid md:grid-cols-3 gap-6">
          {blogPosts.map((blog, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition duration-300">
              <img src={blog.image} alt={blog.title} className="w-full h-48 object-cover" />
              <div className="p-5">
                <h2 className="text-2xl font-semibold text-gray-800">{blog.title}</h2>
                <p className="text-gray-600 mt-2">{blog.excerpt}</p>
                <Link to={`/${blog.slug}`} className="mt-4 inline-block text-[#679729] font-bold hover:underline">
                  Read More →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
     {/* Schema Markup */}
     <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default Blogs;
